"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureStore = void 0;
var redux_1 = require("redux");
var redux_thunk_1 = __importDefault(require("redux-thunk"));
var redux_logger_1 = __importDefault(require("redux-logger"));
var reducer_1 = require("./components/Auth/reducer");
var reducer_2 = __importDefault(require("./components/Intl/reducer"));
var config_1 = require("./config");
function createFakeUserReducer(userName) {
    return function fakeAuthReducer(user) {
        if (user === void 0) { user = { userName: userName, fullName: userName, authenticated: true, roles: [] }; }
        return user;
    };
}
function configureStore(reducers, middlewares, fakeUser) {
    if (middlewares === void 0) { middlewares = []; }
    middlewares.push(redux_thunk_1.default);
    /* istanbul ignore if */
    // eslint-disable-next-line no-underscore-dangle
    if (config_1.PROCESS_ENV.__DEVCLIENT__) {
        middlewares.push(redux_logger_1.default);
    }
    var user = fakeUser ? createFakeUserReducer(fakeUser) : reducer_1.userReducer;
    // eslint-disable-next-line no-underscore-dangle
    var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux_1.compose;
    return (0, redux_1.createStore)((0, redux_1.combineReducers)(__assign({ auth: reducer_1.authReducer, user: user, preferredLocale: reducer_2.default }, reducers)), 
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    composeEnhancers(redux_1.applyMiddleware.apply(void 0, middlewares)));
}
exports.configureStore = configureStore;
